module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_9005.bb8a25e4.png";